import { getAnnouncements } from "store/announcementSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import AnnouncementTable from "./components/AnnouncementTable";

const AnnouncementDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAnnouncements());
  }, [dispatch]);

  return (
    <div>
      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        <AnnouncementTable />
      </div>
    </div>
  );
};

export default AnnouncementDashboard;
